import { render, staticRenderFns } from "./NovidadesPage.vue?vue&type=template&id=2fea73a7&scoped=true"
import script from "./NovidadesPage.vue?vue&type=script&lang=js"
export * from "./NovidadesPage.vue?vue&type=script&lang=js"
import style0 from "./NovidadesPage.vue?vue&type=style&index=0&id=2fea73a7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fea73a7",
  null
  
)

export default component.exports